import React from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { BlogApiData } from "..";

interface AuthorSectionProps {
  formData: BlogApiData;
  onSectionChange: (section: keyof BlogApiData["al_sections"], field: string, value: string) => void;
  onAvatarUpload: (event: React.ChangeEvent<HTMLInputElement>) => void;
  isUploadingAvatar: boolean;
  quillModules: any;
  quillFormats: string[];
}

const AuthorSection: React.FC<AuthorSectionProps> = ({
  formData,
  onSectionChange,
  onAvatarUpload,
  isUploadingAvatar,
  quillModules,
  quillFormats,
}) => {
  return (
    <>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Full Name
          </label>
          <input
            type="text"
            value={formData.al_sections.authorSection.full_name}
            onChange={(e) =>
              onSectionChange(
                "authorSection",
                "full_name",
                e.target.value
              )
            }
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            placeholder="e.g., Ardit Kelmendi"
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Position/Title
          </label>
          <input
            type="text"
            value={formData.al_sections.authorSection.position}
            onChange={(e) =>
              onSectionChange(
                "authorSection",
                "position",
                e.target.value
              )
            }
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            placeholder="e.g., Travel Writer & Local Expert"
          />
        </div>
      </div>
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">
          Author Description
        </label>
        <ReactQuill
          theme="snow"
          value={formData.al_sections.authorSection.description}
          onChange={(value) =>
            onSectionChange("authorSection", "description", value)
          }
          modules={quillModules}
          formats={quillFormats}
          placeholder="e.g., Ardit has been exploring and writing about Albania for over 10 years..."
        />
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            LinkedIn Profile
          </label>
          <input
            type="text"
            value={formData.al_sections.authorSection.linkedin_link}
            onChange={(e) =>
              onSectionChange(
                "authorSection",
                "linkedin_link",
                e.target.value
              )
            }
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            placeholder="e.g., https://linkedin.com/in/ardit-kelmendi"
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Email Address
          </label>
          <input
            type="email"
            value={formData.al_sections.authorSection.email}
            onChange={(e) =>
              onSectionChange(
                "authorSection",
                "email",
                e.target.value
              )
            }
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            placeholder="e.g., ardit@travelalbania.com"
          />
        </div>
      </div>
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">
          Avatar Image
        </label>
        <div className="space-y-3">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Upload Avatar
            </label>
            <div className="relative">
              <input
                type="file"
                accept="image/*"
                onChange={onAvatarUpload}
                disabled={isUploadingAvatar}
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:opacity-50 disabled:cursor-not-allowed text-sm"
              />
              {isUploadingAvatar && (
                <div className="absolute inset-0 flex items-center justify-center bg-white bg-opacity-75 rounded-md">
                  <div className="flex items-center space-x-2">
                    <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-blue-600"></div>
                    <span className="text-xs text-gray-600">
                      Uploading...
                    </span>
                  </div>
                </div>
              )}
            </div>
          </div>
          {formData.al_sections.authorSection.avatar &&
            !isUploadingAvatar && (
              <div className="flex items-center space-x-4 p-3 bg-gray-50 rounded-md">
                <img
                  src={formData.al_sections.authorSection.avatar}
                  alt="Avatar Preview"
                  className="w-16 h-16 object-cover rounded-full border"
                />
                <div>
                  <p className="text-sm text-gray-700">
                    Avatar Preview
                  </p>
                  <button
                    type="button"
                    onClick={(e) => {
                      e.stopPropagation();
                      onSectionChange(
                        "authorSection",
                        "avatar",
                        ""
                      );
                    }}
                    className="text-xs text-red-600 hover:text-red-800">
                    Remove avatar
                  </button>
                </div>
              </div>
            )}
        </div>
      </div>
    </>
  );
};

export default AuthorSection;
